import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GrDocument } from "react-icons/gr";
import { SlNotebook } from "react-icons/sl";
import { IoBookSharp } from "react-icons/io5";
import { FaAngleDown } from "react-icons/fa";
import { FaUniversity } from "react-icons/fa";
import { FaSchool } from "react-icons/fa";
import { useSelector } from "react-redux";
import { IoSpeedometerOutline } from "react-icons/io5";
import { HiDocumentReport } from "react-icons/hi";
const NCLAdminMenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    useEffect(() => {
        setShowTooltip(null);
    }, [location.pathname]);
    const [ShowTooltip, setShowTooltip] = useState();
    return (
        <>
            <div className="NCL-Menu">

                <div className={(props.CheckPath("/InstitutionMaster") || props.CheckPath("/Schools") || props.CheckPath("/QBAdminLogin")
                    || props.CheckPath("/AssessmentParameters")) ? "SubTabSelect" : "TabNotSelect"}
                    style={{ position: "relative" }}
                    onMouseEnter={() => setShowTooltip("Master")}
                    onMouseLeave={() => setShowTooltip()}
                //  onClick={() => setShowTooltip("Master")}
                >Masters <FaAngleDown />

                    {ShowTooltip === "Master" && (
                        <div className="Card dflex flexd-column Main-SubMenu" >
                            <div onClick={() => { navigate("/NCLAdmin/InstitutionMaster", { replace: true }) }}
                                className={props.CheckPath("/InstitutionMaster") ? "SubTabSelect" : "TabNotSelect"}
                            > <FaUniversity /> Institutions </div>

                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/NCLAdmin/Schools", { replace: true })}
                                className={props.CheckPath("/Schools") ? "SubTabSelect" : "TabNotSelect"} >
                                <FaSchool /> Schools </div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div
                                onClick={() => navigate("/NCLAdmin/QBAdminLogin/QBAdminLogin", { replace: true, })}
                                className={props.CheckPath("/QBAdminLogin") ? "SubTabSelect" : "TabNotSelect"} >
                                <IoBookSharp /> QBAdmin Users </div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/NCLAdmin/Parameters/AssessmentParameters", { replace: true, })}
                                className={props.CheckPath("/AssessmentParameters") ? "SubTabSelect" : "TabNotSelect"} >
                                <GrDocument /> Assessment Parameters </div>
                        </div>
                    )}
                </div>

      {/* <div onClick={() =>navigate("/NCLAdmin/StudentsDeactivation", {replace: true})}
    className={props.CheckPath("/StudentsDeactivation")? "SubTabSelect": "TabNotSelect"}>Students Deactivation</div> */}

                <div onClick={() => navigate("/NCLAdmin/Assessments", { replace: true })}
                    className={props.CheckPath("/Assessments") ? "SubTabSelect" : "TabNotSelect"} >
                    <HiDocumentReport /> Assessments </div>

                <div className={(props.CheckPath("/StudentResponses") || props.CheckPath("/AssessmentParticipationReport") || props.CheckPath("/QBReports")
                    || props.CheckPath("/OMRResults") || props.CheckPath("/NCPTech") || props.CheckPath("/RWNOELective") || props.CheckPath("/DownloadDetails")
                    || props.CheckPath("/GeneratePPT") || props.CheckPath("/Practice%20Test%20Reports")
                ) ? "SubTabSelect" : "TabNotSelect"}
                    style={{ position: "relative" }}
                    onMouseEnter={() => setShowTooltip("Reports")}
                    onMouseLeave={() => setShowTooltip()}
                // onClick={() => setShowTooltip("Reports")}
                >Reports <FaAngleDown />

                    {ShowTooltip === "Reports" && (
                        <div className="Card dflex flexd-column Main-SubMenu">
                            {items?.schoolId === "nsfadmintech" && <>
                                <div onClick={() => navigate("/NCPTech", { replace: true })}
                                    className={props.CheckPath("/NCPTech") ? "SubTabSelect" : "TabNotSelect"} >
                                    <IoSpeedometerOutline />Genareate Student Responses </div>
                                <hr className="w-100 m-0" style={{ color: "black" }} /></>}

                            <div onClick={() => navigate("/NCLAdmin/StudentResponses", { replace: true })}
                                className={props.CheckPath("/StudentResponses") ? "SubTabSelect" : "TabNotSelect"} >
                                <IoSpeedometerOutline />Export Student Responses</div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />

                            <div onClick={() => navigate("/NCLAdmin/AssessmentParticipation/AssessmentParticipationReport", { replace: true })}
                                className={props.CheckPath("/AssessmentParticipationReport") ? "SubTabSelect" : "TabNotSelect"} >
                                <GrDocument /> Assessment Participation </div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/NCLAdmin/QBReports", { state: { Tab: "WQC" } })}
                                className={props.CheckPath("/QBReports") ? "SubTabSelect" : "TabNotSelect"} >
                                <SlNotebook /> QB Reports </div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/OMRResults", { state: { Tab: "WQC" } })}
                                className={props.CheckPath("/OMRResults") ? "SubTabSelect" : "TabNotSelect"} >
                                <SlNotebook />Import OMR Responses </div>
                            <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/RWNOELective")}
                                className={props.CheckPath("/RWNOELective") ? "SubTabSelect" : "TabNotSelect"} >
                                {/* className="TabNotSelect" > */}
                                <SlNotebook />Registrations with no elective subject </div>

                                     <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div onClick={() => navigate("/DownloadDetails")}
                                className={props.CheckPath("/DownloadDetails") ? "SubTabSelect" : "TabNotSelect"} >
                                <SlNotebook />Exported Reports Log </div>

                                 <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div  onClick={() => navigate("/GeneratePPT")}
                                 className={props.CheckPath("/GeneratePPT") ? "SubTabSelect" : "TabNotSelect"}  >
                                <SlNotebook />Generate PPT </div>

                                 <hr className="w-100 m-0" style={{ color: "black" }} />
                            <div  onClick={() => navigate("/Practice Test Reports")}
                                 className={props.CheckPath("/Practice%20Test%20Reports") ? "SubTabSelect" : "TabNotSelect"}  >
                                <SlNotebook />Practice Test Tracking </div>
                        </div>
                    )}

                </div>
            </div>        </>
    )
}
export default NCLAdminMenu;